<template>
  <span v-if="header && header.FeMhEstado === 'INVALIDADO'">
    <button
      :class="buttonClass"
      :style="buttonStyle"
      :disabled="loading"
      :aria-busy="loading"
      @click="download"
    >
      Descargar JSON de invalidación
    </button>
    <span v-if="errorMessage" role="alert" style="margin-left: 12px; color: #b71c1c;">
      {{ errorMessage }}
    </span>
  </span>
</template>

<script>
import invoices from "@/api/invoices";

export default {
  name: "DownloadInvalidationJson",
  props: {
    header: { type: Object, default: null },
    buttonClass: { type: String, default: "btnclean" },
    buttonStyle: {
      type: Object,
      default: () => ({ fontSize: "18px", marginLeft: "12px" }),
    },
  },
  data() {
    return { loading: false, errorMessage: "" };
  },
  methods: {
    async download(event) {
      if (this.loading || this.header?.FeMhEstado !== "INVALIDADO") return;
      this.errorMessage = "";
      const invoiceId = this.header.ID_Invoice || this.header.ID_CR;
      if (!invoiceId) {
        this.errorMessage = "No se encontró el identificador del documento.";
        return;
      }
      const doc = event.currentTarget.ownerDocument;
      this.loading = true;
      let url;
      try {
        const json = await invoices.getInvalidationJson(invoiceId);
        if (!json || !json.identificacion || !json.firmaElectronica || !json.selloRecibido) {
          throw new Error("El JSON de invalidación recibido está incompleto.");
        }
        const blob = new Blob([JSON.stringify(json)], { type: "application/json" });
        url = URL.createObjectURL(blob);
        const link = doc.createElement("a");
        link.href = url;
        link.download = `${String(invoiceId).replace(/[^a-zA-Z0-9_-]/g, "_")}-invalidacion.json`;
        doc.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.errorMessage = error.response?.data?.message || error.message ||
          "No se pudo descargar el JSON de invalidación.";
      } finally {
        if (url) URL.revokeObjectURL(url);
        this.loading = false;
      }
    },
  },
};
</script>
